"use client";
import React from "react";
import Image from "next/image";

const outputImages = [
  "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735877203/a720cb676c384fec8063d334ee117afb_1_plf9l3.png",
  "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735877204/2e0d73e604c2f814096af88b7891ac7c_o5nna1.png",
  "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735877204/ef96bcd238590bb498a160fd23c6c5e2_oorgvu.png",
  "https://res.cloudinary.com/dcyrpk68d/image/upload/v1735877203/a720cb676c384fec8063d334ee117afb_1_plf9l3.png",
];

export function MultipleOutputOptions() {
  return (
    <section className="bg-white px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-center gap-12 lg:flex-row lg:gap-20">
        <div className="relative">
          <div className="flex items-center justify-center rounded-lg bg-[#bfe0f2] p-3 sm:rounded-[20px] sm:p-5">
            <Image
              src="https://res.cloudinary.com/dcyrpk68d/image/upload/c_crop,ar_1:1/v1736262397/1be6dc9d00fba82a5796fc427772d65a_mlgg1y.jpg"
              alt="Main showcase"
              width={374}
              height={406}
              className="h-auto w-full max-w-[300px] rounded-lg sm:max-w-[374px] sm:rounded-[20px]"
            />
          </div>
        </div>
        <div className="flex max-w-xl flex-col items-start justify-center gap-10 max-lg:flex-col-reverse sm:gap-20">
          <div className="flex flex-col items-start justify-center gap-5">
            <h2 className="text-2xl leading-tight font-medium text-[#09090f] sm:text-3xl sm:leading-9">
              Unlimited Possibilities
            </h2>
            <p className="text-base leading-normal font-normal text-[#171618] sm:text-lg sm:leading-7">
              Remove backgrounds from any image type - JPG, PNG, HEIC. Download
              in PNG with transparent background or instantly replace with a new
              background. Perfect for designers, e-commerce, social media, and
              digital marketing
            </p>
          </div>
          <div className="mx-auto grid grid-cols-2 gap-4 sm:grid-cols-4 sm:gap-[30px]">
            {outputImages.map((img, index) => (
              <div key={index}>
                <Image
                  src={img}
                  alt={`Output option ${index + 1}`}
                  width={150}
                  height={150}
                  className="h-auto w-full max-w-[150px] rounded-[10px] border-4 border-blue-600"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
